
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cross-chain",
      function () {
        return require("private-next-pages/cross-chain.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cross-chain"])
      });
    }
  